import { createSlice } from "@reduxjs/toolkit";
import { ProductType } from "../data/enums";

export const cartReducer = createSlice({
   name: "cart",
   initialState: {
      itemCount: 0,
      items: window.sessionStorage.getItem("products") ? JSON.parse(window.sessionStorage.getItem("products")) : {},
      payment: false,
      companyData: sessionStorage.getItem("companyDataCart") ? JSON.parse(sessionStorage.getItem("companyDataCart")) : {}
   },
   reducers: {
      resetCart: (state) => {
         state.items = {}
         state.itemCount = 0;
      },
      setPayment: (state, action) => {
         state.payment = action
      },
      addItem: (state, action) => {

         const productsFromSession = window.sessionStorage.getItem("products");
         let cartItems = productsFromSession ? JSON.parse(productsFromSession) : null;
         if (!cartItems) {
            state.items = {};
         }
         sessionStorage.removeItem('products');
         const companyUser = sessionStorage.getItem("company") && sessionStorage.getItem("userDetails") ? true : false

         if (companyUser || action.payload.selectedProduct.productTypeId && action.payload.selectedProduct.productTypeId == ProductType.Goods) {
            const item = state.items[action.payload.selectedProduct.productId];
            if (item === undefined) {
               state.items = {}
               state.items[action.payload.selectedProduct.productId] = {
                  selectedProduct: action.payload.selectedProduct,
                  qty: 1
               };
               state.itemCount = 1;
            }
            else {
               item.qty++;
               state.itemCount++;
            }
            window.sessionStorage.setItem("products", JSON.stringify(state.items));
         }
         else {

            //remove this line if want to add multiple products
            state.items = {};
            const item = state.items[action.payload.selectedProduct.productId];
            if (item === undefined) {
               state.items[action.payload.selectedProduct.productId] = {
                  selectedProduct: action.payload.selectedProduct,
                  qty: 1
               };
               state.itemCount++;
            }
            else {
               item.qty++;
               state.itemCount++;
            }

            // ## start region -  remove this region and uncomment the above if you want to add multiple products
            state.items[action.payload.selectedProduct.productId] = {
               selectedProduct: action.payload.selectedProduct,
               qty: 1
            };
            state.itemCount = 1;
            window.sessionStorage.setItem("products", JSON.stringify(state.items));
            ///// ## end region

         }




      },

      removeItem: (state, action) => {

         const item = state.items[action.payload.productId];
         if (item === undefined) return;
         item.qty === 1 ? delete state.items[action.payload.productId] : item.qty--;
         state.itemCount--;
         sessionStorage.removeItem('products');
         window.sessionStorage.setItem("products", JSON.stringify(state.items));
      },
      setAmount: (state , action) => {
         const item = state.items[action.payload.selectedProduct.productId];
         if (item === undefined) return;
         item.qty = Number(action.payload.qty)
         state.itemCount = Number(action.payload.qty)
         sessionStorage.setItem("products", JSON.stringify(state.items));
      },

      //companyData format { greetingText: '...', workers: [...] }
      setCompanyData: (state, action) => {
        state.companyData = action.payload;
        if (!action.payload) {
            sessionStorage.removeItem("companyDataCart")
         } else {
            sessionStorage.setItem("companyDataCart", JSON.stringify(action.payload))
         }
      }

   }
});
export const { addItem, removeItem, resetCart, setPayment ,setAmount, setCompanyData} = cartReducer.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartCount = (state) => state.cart.itemCount;
export const selectCompanyData = (state) => state.cart.companyData;

export default cartReducer.reducer;